module.exports = __webpack_public_path__ + "assets/img/AboutUsBAPC.4f37f461.png";